/**
 * @generated SignedSource<<7773077216f056492949f29ad43d2116>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useUserOverrides_setOverrideMutation$variables = {
  overridesMap: any;
  scopeId: string;
};
export type useUserOverrides_setOverrideMutation$data = {
  readonly setOverrides: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly user: {
      readonly " $fragmentSpreads": FragmentRefs<"useUserOverrides_user">;
    } | null;
  } | null;
};
export type useUserOverrides_setOverrideMutation$rawResponse = {
  readonly setOverrides: {
    readonly errors: ReadonlyArray<string | null> | null;
    readonly user: {
      readonly id: string;
      readonly overrides: {
        readonly id: string;
        readonly overridesMap: any | null;
      } | null;
    } | null;
  } | null;
};
export type useUserOverrides_setOverrideMutation = {
  rawResponse: useUserOverrides_setOverrideMutation$rawResponse;
  response: useUserOverrides_setOverrideMutation$data;
  variables: useUserOverrides_setOverrideMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "overridesMap"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scopeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "overridesMap",
    "variableName": "overridesMap"
  },
  {
    "kind": "Variable",
    "name": "scopeId",
    "variableName": "scopeId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUserOverrides_setOverrideMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetOverrides",
        "kind": "LinkedField",
        "name": "setOverrides",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "useUserOverrides_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUserOverrides_setOverrideMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetOverrides",
        "kind": "LinkedField",
        "name": "setOverrides",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Overrides",
                "kind": "LinkedField",
                "name": "overrides",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "overridesMap",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "51f6accbe8c940f25d1a7051427de741",
    "id": null,
    "metadata": {},
    "name": "useUserOverrides_setOverrideMutation",
    "operationKind": "mutation",
    "text": "mutation useUserOverrides_setOverrideMutation(\n  $scopeId: ID!\n  $overridesMap: GenericScalar!\n) @team(name: \"cloud-infrastructure\") {\n  setOverrides(scopeId: $scopeId, overridesMap: $overridesMap) {\n    errors\n    user {\n      ...useUserOverrides_user\n      id\n    }\n  }\n}\n\nfragment useUserOverrides_user on User {\n  id\n  overrides {\n    id\n    overridesMap\n  }\n}\n"
  }
};
})();

(node as any).hash = "f25b87740a5c601da9f18f513f6eb59e";

export default node;
